export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SinisterInfo.vue?vue&type=template&id=3dacee79"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/ConceptsValidation/SinisterInfo.vue?vue&type=template&id=3dacee79
// module id = 1748
// module chunks = 31